import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { LeftContainer } from '@pascal/pascal-core';
import { betStore } from '@pascal/pascal-core/shared/core/store';

import { StatisticsWr } from '../index';
import { ResultsWrapper } from '../resultsWrapper';
import { globalTranslationKeys } from '../../../enums';

export const LeftColumn = observer(() => {
  const { Result, Statistics } = globalTranslationKeys;
  const { repliedBetData } = betStore;
  const leftContainerTabs = useMemo(() => [{ name: Result }, { name: Statistics }], []);

  const leftContainerTabsContainers = useMemo(
    () => (repliedBetData ? [] : [<ResultsWrapper />, <StatisticsWr />]),
    [repliedBetData]
  );

  return <LeftContainer tabs={leftContainerTabs} lobbyPath='/' tabContainers={leftContainerTabsContainers} />;
});
